import React from "react";
import { Link } from "react-router-dom";
import { IoPerson } from "react-icons/io5";
import { motion } from "framer-motion";
import description from "../../img/Icon-main.png";

const HeroSection = () => {
  return (
    <section id="home-dash" className="home-dash">
      <div id="dashboard-dashboard" className="row d-flex align-items-center">
       
        <div className="col-sm-4">
          <div className="row">
            <h1>
              <strong>
                Cassava
                <br />
                Super
              </strong>
            </h1>
          </div>
          <div className="row">
            <p>
              Bisnis jual beli mu sangat menguntungkan, ayo bergabung di sini,
              gratis lho!
            </p>
          </div>
          <div className="row">
            <div className="col-sm">
              <Link to="/login" className="btn btn-outline-danger">
                <IoPerson />
                <span style={{ marginLeft: "10px" }}>Log In</span>
              </Link>
            </div>
          </div>
        </div>

        
        <div className="col-md-8">
          <div id="img-icon" className="text-center pb-5">
            <motion.img
              src={description}
              alt="Description"
              className="img-fluid"
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ once: false, amount: 0.2 }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
